import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../Translations';
import Loader from '../../../../Loader';
import LearningCollectionStore from '../../Store';
import Navigation from '../../Edit/CurrentCollectionStep/Navigation';

interface Props {
  store: LearningCollectionStore;
}

const ReloadAllExperiences: React.FC<Props> = ({ store }) => {
  return (
    <div>
      <Navigation store={store}>
        <button
          className={clsx(
            'rounded-md bg-green-600 px-5 py-2.5 text-sm font-semibold text-white',
            'disabled:opacity-75',
          )}
          data-test-continue-button={true}
          disabled
        >
          <T kind="Continue" />
        </button>
      </Navigation>
      <Loader />
    </div>
  );
};

export default observer(ReloadAllExperiences);
